import { render, staticRenderFns } from "./imgBottom.vue?vue&type=template&id=1394147e&scoped=true"
import script from "./imgBottom.vue?vue&type=script&lang=js"
export * from "./imgBottom.vue?vue&type=script&lang=js"
import style0 from "./imgBottom.vue?vue&type=style&index=0&id=1394147e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394147e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1394147e')) {
      api.createRecord('1394147e', component.options)
    } else {
      api.reload('1394147e', component.options)
    }
    module.hot.accept("./imgBottom.vue?vue&type=template&id=1394147e&scoped=true", function () {
      api.rerender('1394147e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/left/imgBottom.vue"
export default component.exports